import { insertIf, join } from 'lib/helpers';
import { VoidCallback } from 'types/callbacks';
import { HTMLProps } from 'react';

import styles from 'components/account/account.module.css';

interface Props extends HTMLProps<HTMLDivElement> {
  label: string;
  register: any;
  hasValue?: boolean;
  displayError?: boolean;
  errorMessage?: string;
  vstack?: boolean;
  button?: boolean;

  onEnter?: VoidCallback;
  placeholder?: string;
  password?: boolean;
}

const AccountField = ({
  label,
  register,
  errorMessage,
  hasValue = true,
  vstack = false,
  password = false,
  button = false,
  placeholder,
  onEnter,
  ...rest
}: Props) => (
  <div
    className={join([
      styles.FieldContainer,
      ...insertIf(vstack, styles.VStack),
    ])}
    {...rest}
  >
    <label>{label}</label>
    <div>
      {button && (
        <span className={styles.InputSpan}>
          <input
            {...register}
            type={password ? 'password' : 'text'}
            placeholder={placeholder}
            onKeyDown={(e) => {
              if (onEnter && e.key === 'Enter') {
                e.preventDefault();
                onEnter();
              }
            }}
          ></input>
          <button
            disabled={hasValue ? false : true}
            onClick={(e) => {
              e.preventDefault();
              onEnter?.();
            }}
          >
            Add
          </button>
        </span>
      )}
      {!button && (
        <input
          {...register}
          type={password ? 'password' : 'text'}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (onEnter && e.key === 'Enter') {
              e.preventDefault();
              onEnter();
            }
          }}
        ></input>
      )}
      {errorMessage && (
        <p className={styles.Error} style={{ margin: '8px 0 0 0' }}>
          {errorMessage}
        </p>
      )}
    </div>
  </div>
);

export default AccountField;
